import React from 'react';
import { Text, Container, Anchor, Stack } from '@mantine/core';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="global-footer">
      <Container size="md">
        <Stack align="center" gap={0}>
          <Text className="footer-mandal-name">Janardanswami Yogabhyasi Mandal, Nagpur</Text>
          <Anchor href="https://jsyog.org" target="_blank" className="footer-link">
            jsyog.org
          </Anchor>
        </Stack>
      </Container>
    </footer>
  );
};

export default Footer;
